import { AnyAction } from 'redux';

import {
    CONTACT_DETAIL_DOCUMENTS_DELETE,
    CONTACT_DETAIL_DOCUMENTS_RECEIVED,
    CONTACT_DETAIL_DOCUMENTS_RENAME,
    CONTACT_DETAIL_DOCUMENTS_UPLOAD_PROGRESS,
    CONTACT_DETAIL_DOCUMENTS_UPLOAD_START,
    CONTACT_DETAIL_DOCUMENTS_UPLOAD_SUCCESS,
} from './contact-detail-documents-actions';
import { ContactDocument } from '../models/contact-detail-document';

export interface ContactDetailDocumentsReducerState {
    documents: ContactDocument[];
}

const initialDocumentsReducerState: ContactDetailDocumentsReducerState = {
    documents: [],
};

export const contactDetailDocumentsReducer = (
    state: ContactDetailDocumentsReducerState = initialDocumentsReducerState,
    action: AnyAction
): ContactDetailDocumentsReducerState => {
    switch (action.type) {
        case CONTACT_DETAIL_DOCUMENTS_RECEIVED: {
            return {
                ...state,
                documents: action['contactDocuments'],
            };
        }

        case CONTACT_DETAIL_DOCUMENTS_RENAME: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...nextDocuments[index], title: action['title'] };
            return { ...state, documents: nextDocuments };
        }

        case CONTACT_DETAIL_DOCUMENTS_DELETE: {
            return {
                ...state,
                documents: state.documents.filter(document => document.id !== action['id']),
            };
        }

        case CONTACT_DETAIL_DOCUMENTS_UPLOAD_START: {
            return {
                ...state,
                documents: [...state.documents, action['document']],
            };
        }

        case CONTACT_DETAIL_DOCUMENTS_UPLOAD_PROGRESS: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...nextDocuments[index], uploadProgress: action['progress'] };
            return {
                ...state,
                documents: nextDocuments,
            };
        }

        case CONTACT_DETAIL_DOCUMENTS_UPLOAD_SUCCESS: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...action['document'], uploadProgress: undefined };
            return {
                ...state,
                documents: nextDocuments,
            };
        }

        default: {
            return state;
        }
    }
};
